import { Select } from 'antd'
import { useI18n } from 'src/context/i18n.context'

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useI18n()

  return (
    <Select
      value={language}
      onChange={setLanguage}
      className="min-w-36"
      options={[
        { value: 'id', label: t('common.indonesian') },
        { value: 'en', label: t('common.english') },
      ]}
      aria-label={t('common.language')}
    />
  )
}

export default LanguageSwitcher
